import React from 'react';

import { CompareFeature } from '@/components/sections/product-compare/compare-details/compare-feature';
import { CompareRemark } from '@/components/sections/product-compare/compare-details/compare-remark';
import { CompareSummary } from '@/components/sections/product-compare/compare-details/compare-summary';
import { Button } from '@/components/shared/buttons/button';
import { Box } from '@/components/shared/layout/box';
import {
  ICVCompareFeatures,
  ICVCompareRemark,
  ICVCompareSection,
} from '@/contents/cv/cv-compare';
import {
  ILCVCompareFeatures,
  ILCVCompareRemark,
  ILCVCompareSection,
} from '@/contents/lcv/lcv-compare';
import { CvModelClassWithCvModel } from '@/services/contentstack/models/cv-model-class';
import { LcvModel } from '@/services/contentstack/models/lcv-model';
import { IButton } from '@/types/shared';

export interface BaseCompareDetailProps {
  summary: ICVCompareSection | ILCVCompareSection;
  remark: ILCVCompareRemark | ICVCompareRemark;
  feature: ILCVCompareFeatures | ICVCompareFeatures;
  models: LcvModel[] | CvModelClassWithCvModel[];
  hasTextFromIcon?: boolean;
  backButton?: IButton;
}

export const CompareDetails: React.FunctionComponent<
  BaseCompareDetailProps
> = ({
  summary,
  remark,
  feature,
  models,
  hasTextFromIcon,
  backButton,
}: BaseCompareDetailProps) => {
  return (
    <>
      <CompareSummary
        id={summary.id}
        title={summary.title}
        items={summary.items}
        models={models}
        hasTextFromIcon={hasTextFromIcon}
      />
      <CompareFeature items={feature.items} models={models} />
      <CompareRemark title={remark.title} detailHtml={remark.description} />
      {!!backButton?.url && (
        <Box marginBottom="12" textAlign="center">
          <Button
            icon={backButton.icon}
            label={backButton.label}
            href={backButton.url}
            target={backButton.target}
            border={backButton.type === 'border'}
            variant="button-gray"
            tracking={{
              dataTrack: 'product-compare-cta',
              dataTrackText: backButton.label,
              dataTrackUrl: backButton.url,
              dataTest: 'button_back',
            }}
          />
        </Box>
      )}
    </>
  );
};

CompareDetails.displayName = 'CompareDetails';
